import { HttpClient, URL_API } from "../../network";

export type TCreateRewardCodesPayload = {
  reward_program_id: string;
  reward_type_code: string;
  value: number;
  quantity_codes: number;
  expiry_datetime: string;
};

export type TImportRewardCodesPayload = FormData;

class RewardsServiceApi extends HttpClient {
  getListRewards = async (params: TParams) => {
    const data = await this.instance.get(URL_API.REWARDS.GET_LIST, {
      params,
    });
    return data;
  };

  getTotalByUser = async ({ user_id }: { user_id?: string }) => {
    const data = await this.instance.get(URL_API.REWARDS.GET_POINTS_STATISTIC, {
      params: { user_id },
    });
    return data;
  };

  getDetailReward = async (idReward: string) => {
    const { data } = await this.instance.get(
      URL_API.REWARDS.GET_DETAIL + `/${idReward}`
    );
    return data;
  };

  createRewardCodes = async (dataCreate: TCreateRewardCodesPayload) => {
    const { data } = await this.instance.post(
      URL_API.REWARDS.CREATE + "/generate-batch",
      dataCreate
    );
    return data;
  };

  importRewardCodes = async (payload: TImportRewardCodesPayload) => {
    const { data } = await this.instance.post(
      URL_API.REWARD_CODES.IMPORT,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return data;
  };

  assignReward = async (rewardId: string, userId: string) => {
    const { data } = await this.instance.post(
      `/v1/rewards/${rewardId}/assign`,
      { user_id: userId }
    );
    return data;
  };
  markAsUsed = async (rewardId: string, userId: string) => {
    const { data } = await this.instance.post(
      `/v1/rewards/${rewardId}/mark-as-used`,
      { user_id: userId }
    );
    return data;
  };

assignRewardToChargeSession = async (rewardId: string, chargeSessionId: string) => {
  const { data } = await this.instance.post(
    `/v1/rewards/${rewardId}/assign-to-charge-session`,
    { charge_session_id: chargeSessionId }
  );
  return data;
};
}

export const RewardsService = new RewardsServiceApi();
